import type { ResolverType, SortKey, TabKey } from "@/lib/types";
import { TAB_GROUPS } from "@/lib/types";

/** UI 측 필터 — 모두 옵셔널 + tri-state ('any' = 미적용). */
export interface MonitorFilters {
  from?: string; // ISO datetime
  to?: string;
  user_id?: string;
  user_name?: string;
  answered: "any" | "true" | "false";
  saved: "any" | "true" | "false";
  feedback: "any" | "pos" | "neg" | "none";
  slow_threshold_ms?: number;
  q?: string;
  sort: SortKey;
  // ── 액션 라우팅 필터 (v0.1) ──
  tab: TabKey;                       // 대시보드 탭 (all/qa/meeting/summary/...)
  resolver?: ResolverType | "any";   // 분기 사유
  conversation_id?: string;          // 단일 대화 추적
  channel: "any" | "nw" | "web";     // 채널 (NW 봇 / 웹)
  /** 삭제(숨김) 처리한 이력도 함께 보기 — 복원 화면. 기본 false. */
  include_deleted: boolean;
}

export const DEFAULT_FILTERS: MonitorFilters = {
  answered: "any",
  saved: "any",
  feedback: "any",
  // 기본 미적용 — 100 고정 시 response_ms<100(예: stream_push) 행이 목록에서 숨던 문제. 필요 시 사용자가 직접 입력.
  slow_threshold_ms: undefined,
  sort: "time_desc",
  tab: "all",
  resolver: "any",
  channel: "any",
  include_deleted: false,
};

/** UI tri-state → 백엔드 query 변환. */
export function toQueryParams(f: MonitorFilters): Record<string, string | number | boolean | undefined> {
  const actions = TAB_GROUPS[f.tab];
  const actionParam =
    f.tab === "all" ? undefined : actions.join(",");
  return {
    from: f.from || undefined,
    to: f.to || undefined,
    user_id: f.user_id || undefined,
    user_name: f.user_name || undefined,
    answered: f.answered === "any" ? undefined : f.answered,
    saved: f.saved === "any" ? undefined : f.saved,
    slow_threshold_ms: f.slow_threshold_ms ?? undefined,
    q: f.q || undefined,
    sort: f.sort,
    action_type: actionParam,
    resolver: f.resolver && f.resolver !== "any" ? f.resolver : undefined,
    conv: f.conversation_id || undefined,
    channel: f.channel === "any" ? undefined : f.channel,
    // false 는 기본값이므로 아예 보내지 않는다(buildUrl 이 undefined 를 생략).
    include_deleted: f.include_deleted ? true : undefined,
  };
}
